var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.335,
    height: 15.556,
    viewBox: "0 0 16.335 15.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2459",
    "data-name": "Grupo 2459",
    transform: "translate(-344.444 -63.222)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_702",
    "data-name": "Ret\\xE2ngulo 702",
    width: 2,
    height: 20,
    rx: 1,
    transform: "translate(359.364 63.222) rotate(45)",
    fill: "#272f4c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_703",
    "data-name": "Ret\\xE2ngulo 703",
    width: 2,
    height: 20,
    rx: 1,
    transform: "translate(344.444 64.636) rotate(-45)",
    fill: "#272f4c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.230dd790280319f475ad167f9a475f0e.svg";
export { ForwardRef as ReactComponent };